import { Dialog, GenericSuspense, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useCallback } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

const ProjectTimeOffCreateContainer = () => {

    const [TITLE, EDIT_TITLE] = useTranslations(i18n);

    const { id } = useParams();

    const navigate = useNavigate()
    const urlParamsToString = useUrlParamsValueToString()

    const handleClose = useCallback(() => {
        navigate(`..?${urlParamsToString}`)
    }, [urlParamsToString])

    const title = id ? EDIT_TITLE : TITLE

    return (
        <Dialog open title={title} onClose={handleClose} className="">
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </Dialog>
    );
};
export default ProjectTimeOffCreateContainer;

const i18n = ["BSMRH.Calendar.TimeOff.Create.Dialog.Title", "BSMRH.Calendar.TimeOff.Edit.Dialog.Title"];